{
  "common": {
    "productNoun": {
      "form": "formulär",
      "survey": "undersökning",
      "quiz": "quiz"
    },
    "productNounCapitalized": {
      "form": "Formulär",
      "survey": "Undersökning",
      "quiz": "Quiz"
    },
    "urlField": {
      "settingsTitle": "Definiera inställningar för URL-fält",
      "description": "Välj vilka URL-typer som är tillåtna för det här fältet.",
      "allowAllDomains": "Tillåt alla domäner",
      "allowAllDomainsDescription": "Any valid URL is accepted.",
      "allowOnlyDomains": "Tillåt endast dessa domäner",
      "allowOnlyDomainsDescription": "Allt annat nekas.",
      "blockDomains": "Blockera dessa domäner",
      "blockDomainsDescription": "Everything else is accepted.",
      "domainsAllowed": "Tillåtna domäner",
      "domainsBlocked": "Blockerade domäner",
      "domainPlaceholder": "t.ex. example.com",
      "domainPlaceholderAdd": "Lägg till ytterligare ett",
      "domainHint": "Ange en domän och tryck på Enter för att lägga till.",
      "invalidDomain": "Ange en giltig domän utan http://, https:// eller en sökväg.",
      "domainRequired": "Lägg till minst en domän för det här alternativet.",
      "singleUrlInfo": "Endast en URL stöds per fält. Om du vill registrera flera URL:er skapar du separata fält."
    },
    "px": "px",
    "px_uppercase": "PX",
    "seconds": "sekunder",
    "other": "-- Annan --",
    "customFieldExistsError": "Anpassad Fält med det här namnet finns redan",
    "requiredField": "Det här fältet är obligatoriskt",
    "uniqueKeyNotUniqueError": "Denna Nyckel är inte unik",
    "save": "Spara",
    "saving": "Sparar",
    "typeAnOption": "Ange ett alternativ",
    "unsaved": "Osparad",
    "noSubmissionsFound": "Inga inlämningar hittades",
    "sortBy": "Sortera efter",
    "clearAll": "Rensa alla",
    "submitSurvey": "Skicka in undersökningen",
    "select": "Välj",
    "data": "data",
    "enterAmount": "Ange belopp",
    "disqualifyAfterSubmitLower": "Diskvalificera efter inlämning",
    "errorRetryAgain": "Fel, försök igen",
    "savedSuccessfully": "Sparat!",
    "couldntSaveChanges": "Det gick inte att spara ändringarna. Försök igen.",
    "emailNotificationSettingsUpdated": "Dina inställningar för e-postavisering har uppdaterats.",
    "autoResponderSettingsUpdated": "Dina inställningar för autosvar har uppdaterats.",
    "bubbleRadioStyleImageAlt": "Bubble-stil för alternativknapp",
    "standardRadioStyleImageAlt": "Standardstil för alternativknapp",
    "recurringFrequency": {
      "once": "En gång",
      "daily": "Dagligen",
      "weekly": "Varje vecka",
      "monthly": "Varje månad",
      "yearly": "Varje år"
    },
    "saveExitConfirmationSubText": "Visa en bekräftelsemodal när användaren lämnar sidan.",
    "yes": "Ja",
    "no": "Nej",
    "updated": "Uppdaterad",
    "new": "Ny",
    "title": "Titel",
    "openSettings": "Öppna inställningar",
    "cloneField": "Klona fält",
    "removeField": "Ta bort fält",
    "description": "Beskrivning",
    "cannotAddThisField": "Du kan inte lägga till det här fältet",
    "overallOnly": "Endast övergripande",
    "nextSlideDefault": "Nästa bild (Standard)",
    "nextQuestion": "Nästa fråga",
    "searchAddress": "Sök efter adress",
    "recurringDonation": "Återkommande donation",
    "recurringDonationDay": "Återkommande donation 1 dag",
    "recurringDonationWeek": "Återkommande donation 1 gång per vecka",
    "recurringDonationMonth": "Återkommande donation 1 månad",
    "recurringDonationYear": "Återkommande donation 1 år",
    "integrate": "Integrera",
    "preview": "Förhandsgranska",
    "back": "Tillbaka",
    "alert": "Avisering",
    "proceed": "Fortsätt",
    "confirm": "Bekräfta",
    "cancel": "Avbryt",
    "delete": "Radera",
    "embed": "Inbäddad",
    "link": "Länk",
    "linkModal": {
      "title": "Infoga länk",
      "urlLabel": "URL",
      "urlPlaceholder": "https://www.exempel.com",
      "invalidUrl": "URL:en är ogiltig"
    },
    "iframeEmbed": "Iframe-inbäddning",
    "styles": "Stilar",
    "options": "Alternativ",
    "quickAdd": "Snabbtillägg",
    "customFields": "Anpassade fält",
    "addObjectFields": "Lägg till objektfält",
    "personalInfo": "Personuppgifter",
    "contactInfo": "Kontaktuppgifter",
    "submit": "Skicka",
    "address": "Adress",
    "customized": "Anpassad",
    "layout": "Layout",
    "showLabel": "Visa etikett",
    "showImage": "Visa bild",
    "imageLayout": "Bild Innehållsjustering",
    "imageLayoutSettings": "Bild Innehållsjustering Config",
    "imageLayoutMode": "Bild Innehållsjustering Läge",
    "surveyDefault": "Undersökning Standard",
    "independent": "Självständig",
    "image": "Bild",
    "desktop": "Dator",
    "mobile": "Mobil",
    "desktopImage": "Dator Bild",
    "mobileImage": "Mobil Bild",
    "uploaded": "Uppladdat",
    "changeImage": "Ändra bild",
    "uploadImage": "Ladda upp foto",
    "remove": "Ta bort",
    "background": "Bakgrund",
    "buttonBackground": "Knapp Bakgrund",
    "gradient": "Gradient",
    "type": "Typ",
    "linear": "Linjär",
    "radial": "Radial",
    "angular": "Angular",
    "angle": "Vinkel",
    "stops": "Stopp",
    "startColor": "Startfärg",
    "endColor": "Slutfärg",
    "addColor": "Lägg till färg",
    "fontColour": "Typsnitt",
    "textFontColour": "Teckenfärg för text",
    "subTextFontColour": "Teckenfärg för undertext",
    "selectThemes": "Välj Tema",
    "selectOne": "Välj en",
    "enableIcon": "Aktivera ikonen",
    "iconType": "Typ av ikon",
    "iconPlacement": "Ikonplacering",
    "filled": "Ifylld",
    "textOnly": "Endast Brödtext",
    "border": "Kantlinje",
    "borderType": "Kantlinjetyp",
    "cornerRadius": "Hörnradie",
    "width": "Bredd",
    "padding": "Utfyllnad",
    "top": "Toppen",
    "bottom": "Botten",
    "left": "Vänster",
    "right": "Höger",
    "center": "Centrera",
    "default": "Standard",
    "formDefault": "Standardformulär",
    "shadow": "Skugga",
    "color": "Färg",
    "horizontal": "Horisontell",
    "vertical": "Vertikal",
    "blur": "Oskärpa",
    "spread": "Storlek",
    "fieldStyle": "Fältstil",
    "fontColor": "Typsnittsfärg",
    "inputTextFillColor": "Fyllnadsfärg för inmatningstext",
    "inputTextColor": "Textfärg för inmatning",
    "primaryColor": "Primärfärg",
    "primaryColorTooltip": "Kontrollerar Färg för hovringsläge och Dynamisk Land.",
    "primaryColorTooltipLearnMore": "Mer information",
    "inputTextColorTooltip": "Kontrollerar Färg av SMS:a som skrivs in i feedback Fält.",
    "mapPrimaryColorToButtonColor": "Mappa PRIMÄR Färg till Knapp Färg",
    "label": "Etikett",
    "fontFamily": "Typsnittsfamilj",
    "size": "Storlek",
    "weight": "Tjocklek",
    "fontWeightTooltip": "Tillämpligt för eventuella stycken",
    "fontWeightOptions": {
      "thin": "100 - Tunn",
      "extraLight": "200 – Extra Light",
      "light": "300 - Light",
      "normal": "400 – Normal",
      "medium": "500 - Medium",
      "semiBold": "600 – Halvfet",
      "bold": "700 – Fet"
    },
    "placeholder": "Platshållare",
    "customCSS": "Anpassad CSS",
    "backgroundImage": "Bakgrundsbild",
    "headerImage": "Sidhuvudbild",
    "miscellaneous": "Övrigt",
    "agencyBranding": "Byråns varumärke",
    "imageUploadMessage": "Klicka på eller dra en bild till det här området för att ladda upp",
    "backgroundImageTooltipMessage": "Bakgrundsbilden är avsedd att täcka hela sidan och ger en visuellt tilltalande bakgrund för formuläret. För att se bakgrundsbilden klickar du på på alternativet Förhandsgranska.",
    "headerImageTooltipMessage": "Sidhuvudbilden är utformad för att täcka hela formulärets bredd och placeras högst upp i formuläret. För att se sidhuvudbilden klickar du alternativet Förhandsgranska.",
    "onSubmit": "Vid inlämning",
    "facebookPixelID": "Facebook Pixel-ID",
    "facebookPixelFunnelLabel": "Använder du det här inuti en tratt?",
    "facebookPixelFunnelText": "Lämna det tomt – trattens egna inställningar för samtycke till Pixel och cookies gäller.",
    "facebookPixelEmbedLabel": "Bädda in på en annan webbplats?",
    "facebookPixelEmbedText": "Välj hur cookiesamtycke ska hanteras i steget för inbäddningskod.",
    "facebookPixelConsentCallout": "Cookiesamtycke ställs in för varje inbäddning, under",
    "facebookPixelConsentCalloutLink": "Integrera → Bädda in kod",
    "facebookPixelEvents": "Facebook Pixel-händelser",
    "onpageView": "Vid sidvisning",
    "stickyContact": "Fäst kontakt",
    "stickyContactMessage": "Kommer ihåg och fyller automatiskt i kontaktuppgifter när användaren använder samma enhet och webbläsare.",
    "generateSubmissionDocument": "Generera inlämningsdokument",
    "generateSubmissionDocumentMessage": "Skapa automatiskt en utskrivbar PDF av varje inlämning och bifoga den till kontaktens dokument",
    "saveQuizSubmissionAsPdf": "Spara quizinlämning som en PDF",
    "saveQuizResultAsPdf": "Spara quizresultatet som PDF",
    "showSubmissionInConversationsFeed": "Skapa konversation vid inlämning",
    "showSubmissionInConversationsFeedMessage": "Skapa automatiskt en konversationstråd när det här formuläret skickas, så att ni kan följa upp via e-post, SMS eller andra kanaler från fliken Konversationer.",
    "fieldDescription": "Fältbeskrivning",
    "fieldTitle": "Fälttitel",
    "queryKey": "Frågenyckel",
    "querykeyTooltipMessage": "Frågenyckeln som kan användas som URL-parameter för att fylla i det här fältet",
    "required": "Krävs",
    "hidden": "Dold",
    "hiddenValue": "Dolt värde",
    "enableCountryPicker": "Aktivera landsväljare",
    "altText": "Alt-text",
    "optionImageAlt": "Alternativbild",
    "bannerAlt": "banner",
    "avatarAlt": "Avatar-namn",
    "alignment": "Orientering",
    "imageWidth": "Bildbredd",
    "imageHeight": "Bildhöjd",
    "logic": "Logik",
    "pleaseInput": "Ange",
    "editHTML": "Redigera HTML",
    "textStyle": "Textformat",
    "subText": "Undertext",
    "text": "Text",
    "buttonStyle": "Knappstil",
    "fullWidth": "Full bredd",
    "htmlMessage": "Anpassad HTML anges här",
    "htmlEditorHeader": "ANPASSAD JAVASCRIPT / HTML",
    "htmlEditorBodyMessage": "Lägg till din kod här",
    "scriptAdded": "Script har lagts till!",
    "sourceAddedForm": "Källan ”Formulärnamn”",
    "sourceAddedSurvey": "Källan ”Enkätens namn”",
    "sourceAddedQuiz": "Källan ”Quiznamn”",
    "yesSave": "Ja, spara",
    "cancelKeep": "Avbryt, behåll",
    "done": "Klar",
    "addElement": "Lägg till element",
    "addUrlLike": "Inkludera giltiga URL:er såsom",
    "doNotAddRelativePath": "Lägg inte till relativa sökvägar som",
    "or": "eller",
    "addCustomFields": "Lägg till anpassade fält",
    "customFieldSearch": "Search by name",
    "selectedCount": "{count} markerade",
    "noFieldsFound": "Inga fält hittades",
    "noFieldsMatchQuery": "Inga fält matchar {query}. Försök med en annan term eller skapa ett nytt fält.",
    "clearSearch": "Rensa sökning",
    "addFieldWithCount": "Lägg till {count} fält | Lägg till {count} fält",
    "noFieldsYet": "Inga fält ännu",
    "noFieldsForObject": "Det här objektet har inga fält ännu. Skapa ett för att komma igång.",
    "createField": "Skapa fält",
    "enterSourceValue": "Ange källvärde",
    "shortLabel": "Kort etikett",
    "shortLabelPlaceholder": "Typsnitt a Kort etikett",
    "labelPlaceholder": "Typ en etikett",
    "imagePlaceholder": "Bild",
    "fillValuesPlaceholder": "Lägg till värden",
    "customCSSTooltip": "Anpassad CSS har företräde framför formulärformatering och teman och kan ha en inverkan på temats stil.",
    "fontFamilyTooltip": "Byggverktyget stöder alla typer av typsnitt om du inte kan se det i listan. Sök i rullgardinsmenyn",
    "angleTooltip": "Kontrollerar gradientens riktning. 0° är åt höger, 90° är nedåt, 180° är åt vänster, 270° är uppåt.",
    "useGDPRCompliantFont": "Använd GDPR-kompatibelt typsnitt",
    "enableTimezone": "Aktivera tidszon",
    "inputStyle": "Inmatningsstil",
    "conditionalLogicAlertOnSubmit": "Villkorlig logik kommer att ha företräde framför meddelandet/omdirigeringen här",
    "conditionalLogicAlertOnShowHide": "Villkorlig logik kommer att ha företräde framför de dolda inställningarna här",
    "placeholderFacebookPixelIdInput": "Ange Facebook Pixel-ID",
    "doNotShowMessage": "Visa inte igen",
    "creatingForm": "Skapade din Formulär ...",
    "creatingSurvey": "Skapade din Undersökning...",
    "creatingQuiz": "Skapade ditt quiz ...",
    "errorCreatingForm": "Där var ett fel skapat din Formulär. Försök igen.",
    "errorCreatingSurvey": "Där blev det ett fel skapade din Undersökning. Försök igen.",
    "errorCreatingQuiz": "Där var ett fel skapade ditt quiz. Försök igen.",
    "redirectMessage": "Du omdirigeras till:",
    "themes": {
      "themes": "Teman",
      "alertThemeMessage": "Om du byter tema kommer du att förlora alla ändringar av den aktuella stilen.",
      "useTheme": "Använd tema",
      "removeTheme": "Ta bort tema"
    },
    "box": "Ruta",
    "line": "Rad",
    "message": "Meddelande",
    "openUrl": "Omdirigera till URL",
    "borderTypeList": {
      "dotted": "Prickad",
      "dashed": "Streckad",
      "solid": "Helfärgad",
      "none": "Ingen"
    },
    "button": "Knapp",
    "emailNotification": "E-postavisering",
    "emailNotificationSubheader": "Få ett e-postmeddelande när någon fyller i ditt formulär",
    "subject": "Ämne",
    "emailTo": "E-post (till)",
    "senderName": "Avsändarens namn",
    "senderNameWarning": "Ditt (underkontonamn) läggs till om det lämnas tomt",
    "emailError": "Minst en e-postadress krävs",
    "emailTooltip": "Ange en eller flera e-postadresser som ska ta emot denna formulärinlämningsvarning. Den första adressen skrivs i ”Till”; ytterligare adresser behandlas som ”CC”.",
    "emailTooltipForm": "Ange en eller flera e-postadresser som ska ta emot denna formulärinlämningsvarning. Den första adressen skrivs i ”Till”; ytterligare adresser behandlas som ”CC”.",
    "emailTooltipSurvey": "Ange en eller flera e-postadresser som ska få denna undersökningsinlämningsvarning. Den första adressen skrivs i ”Till”; ytterligare adresser behandlas som ”CC”.",
    "emailTooltipQuiz": "Ange en eller flera e-postadresser som ska få denna quizinlämningsvarning. Den första adressen skrivs i ”Till”; ytterligare adresser behandlas som ”CC”.",
    "clear": "Rensa",
    "filter": "Filter",
    "noResults": "Inga resultat",
    "search": "Sök",
    "showNotificationsSettings": "Visa aviseringsinställningar",
    "emailServicePaid": "Den här funktionen är en betald tjänst och kommer att medföra avgifter baserat på din användning.",
    "integration": "Integration",
    "validation": {
      "fieldRequired": "Fält är Krävs",
      "maxLengthExceeded": "Max längd har överskridits ({max} Tecken)"
    },
    "securityValidation": {
      "title": "Säkerhetsproblem har upptäckts. Följande är inte tillåtna:",
      "cookieAccess": "Cookie-åtkomst upptäckt (document.cookie). Detta är inte tillåtet av säkerhetsskäl.",
      "storageAccess": "localStorage.getItem() – att läsa från localStorage är inte tillåtet.",
      "evalUsage": "Användning av eval() är inte tillåtet eftersom den kan köra godtycklig kod.",
      "dynamicFunction": "Dynamisk funktionsskapande (ny funktion) är inte tillåtet av säkerhetsskäl.",
      "stringExecution": "Det är inte tillåtet att skicka strängar till setTimeout/setInterval eftersom det kan köra godtycklig kod. Använd funktionsreferenser istället.",
      "unclosedTag": "En oavslutad HTML-tagg upptäcktes (till exempel en <style> utan en avslutande </style>). Stäng alla taggar innan du sparar, annars kan det hända att den publicerade sidan inte laddas."
    },
    "products": {
      "subscriptionBadge": "Abonnemang",
      "trialBadge": "{days} dagars gratis provperiod",
      "setupFee": "Engångsavgift för konfiguration",
      "quantity": "Antal",
      "productImageAlt": "Produktbild",
      "bumpIconAlt": "Bump-ikon"
    },
    "payment": {
      "payments": "Betalningar",
      "paymentProviders": "Betalningsleverantörer",
      "paymentProvidersDescription": "Anslut en betalningsleverantör för att börja ta emot betalningar.",
      "connectedProviders": "Anslutna leverantörer",
      "requireCreditCard": "Kräv kort för order på 0 kr",
      "requireCreditCardTooltip": "När det är aktiverat måste kunderna ange ett kreditkort även för köp på 0 kr.",
      "connectProviders": "Anslut leverantörer",
      "loading": "Läser in ...",
      "generalTab": "Allmänt",
      "productTab": "Produkt",
      "connected": "Ansluten",
      "connect": "Anslut",
      "liveModeOn": "Live-läge",
      "status": "Status",
      "test": "Test",
      "live": "Live",
      "paymentFields": "Betalningsfält",
      "suggestAnAmount": "Föreslå ett belopp",
      "recurringPayments": "Återkommande betalningar",
      "selectCurrency": "Välj valuta",
      "tagActiveBGColor": "Färg på aktiv tagg",
      "includeOtherAmount": "Inkludera annat belopp",
      "footerInfo": "Sidfotsinfo",
      "paymentType": "Betalningstyp",
      "sellProducts": "Sälj produkter",
      "customAmount": "Anpassat belopp",
      "collectPayment": "Ta ut betalning",
      "generalSettings": "Allmänna fält",
      "securePayments": "*100 % Lås & säkra betalningar*",
      "error": {
        "addMainProductFirst": "Lägg till en PRIMÄR Produkt först",
        "priceNotFoundForBumpProduct": "Pris hittades inte för Tilläggsprodukt",
        "productAlreadyAdded": "Produkt har redan lagts till"
      },
      "product": {
        "addProduct": "Lägg till produkt",
        "productSettings": "Produktinställningar",
        "bumpTag": "Ytterligare val",
        "settingsAria": "Produktinställningar",
        "deleteAria": "Radera produkt",
        "selectProduct": "Välj produkt",
        "editThisProduct": "För att redigera produkten",
        "clickHere": "Klicka här",
        "show": "Visa",
        "description": "Beskrivning",
        "image": "Bild",
        "layoutSettings": "Layoutinställningar",
        "singleColumn": "En kolumn",
        "twoColumn": "Två kolumner",
        "threeColumn": "Tre kolumner",
        "maxProductError": "Max 20 produkter är tillåtna i ett formulär",
        "productSelectPlaceholder": "Välj en produkt",
        "orderConfirmation": "Beställningsbekräftelse",
        "orderConfirmationWarning": "Sidan med beställningsbekräftelsen visas när betalningen har genomförts",
        "quantity": "Antal",
        "createProduct": "Så här skapar du en produkt",
        "noProductsAdded": "Inga produkter har lagts till än",
        "productsWillShowHere": "När Du Inkludera produkter kommer de Visa upp Höger här",
        "chooseProductType": "Välj Produkt Typ",
        "mainProduct": "PRIMÄR Produkt",
        "primaryOffer": "Primärt erbjudande",
        "checkoutAddOn": "Kassa-tillägg",
        "pricingOptions": "Prisalternativ",
        "pricingOptionsPlaceholder": "Välj prissättningsalternativ (standard: alla)",
        "all": "ALLA",
        "addOrSelectProducts": "Lägg till eller välj produkter",
        "onceYouAddProductsTheyWillShowUpRightHere": "När du har lagt till produkter visas de här",
        "addProducts": "Lägg till produkter"
      },
      "bumProduct": {
        "price": "Pris",
        "variant": "Variant",
        "headline": "Rubrik",
        "otoHeadline": "OTO Rubrik",
        "otoText": "OTO Brödtext",
        "enableImage": "Aktivera Bild",
        "imageMessage": "Vi tar Standard Produkt Bild",
        "orUploadADifferentImage": "Eller Ladda upp en annan Bild",
        "bumpProducts": "Bump-produkter",
        "bumpProduct": "Tilläggsprodukt",
        "enableBump": "Aktivera Bump",
        "orderBumpStyle": "Beställningstillägg Stil",
        "classic": "Klassisk",
        "modern": "Modernt",
        "icon": "Ikon",
        "bumpTemplate": "Välj Mall",
        "highlightText": "Markera Brödtext",
        "showPrice": "Visa Pris",
        "bumpPriceColor": "Högre Pris",
        "bumpIconColor": "Bump Ikon",
        "bumpBackgroundColor": "Bump Bakgrund",
        "highlightTextColor": "Markera Brödtext",
        "headlineColor": "Rubrik",
        "otoHeadlineColor": "OTO Rubrik",
        "otoTextColor": "OTO Brödtext",
        "bumpBorderColor": "Bump Kantlinje",
        "priceRequired": "Pris är Krävs",
        "headlineRequired": "Rubrik är Krävs",
        "otoHeadlineRequired": "OTO-rubrik krävs",
        "otoTextRequired": "OTO-text krävs",
        "bumpProductTooltip": "Ett Liten Tillägg erbjöds under Kassa till Multiplicera Sortera Värde. Kunder kan Inkludera det med en Individ-klick.",
        "templateOne": "Mall 1",
        "templateTwo": "Mall 2",
        "templateThree": "Mall 3",
        "animationIcon": {
          "none": "Ingen",
          "arrow": "Pil",
          "fire": "Brand",
          "plus": "Plus",
          "giftBox": "Ruta",
          "timer": "Nedräkning",
          "cracker": "Knackare",
          "snack": "Mellanmål",
          "partyBalloon": "Festballong",
          "flash": "Blixt",
          "money": "Valuta",
          "spaceShuttle": "Yta"
        }
      },
      "coupons": {
        "coupons": "Kuponger",
        "enableCoupon": "Aktivera kupong",
        "couponAlignment": "Kupongjustering",
        "left": "Vänster",
        "right": "Höger",
        "fullWidth": "Full bredd",
        "tooltipMessage": "Ställ in positionen för kuponginmatning från typerna nedan"
      }
    },
    "addressSettings": {
      "autoComplete": "Adress fylls i automatiskt",
      "addressfields": "Adressfält",
      "placeholderSearch": "Sök efter en adress",
      "autoCompleteTooltip": "Gör det möjligt söka efter och automatiskt fylla i adress.",
      "streetAddress": "Adress",
      "autoCompleteAddressTitle": "Auto Slutför Adress",
      "newBadge": "Ny",
      "defaultLabel": "Adress",
      "searchPlaceholder": "Sök adress",
      "mandataorySearch": {
        "title": "Krävs till Välj adress in Sök Bar",
        "primaryText": "Automatisk komplettering endast för Adress",
        "secondaryText": "När Aktiverad, När a Användare interagerar med Adressfältet, Sedan måste de välja en giltig adress till Fortsätt.",
        "secondaryText1": "När Inaktiverad Sedan kan de Fortsätt utan att välja en adress in fältet Sök."
      }
    },
    "autoResponder": "Autosvar",
    "workflow": "Arbetsflöde",
    "workflowSubheader": "Automatisera vad som händer efter att ett formulär har skickats in",
    "workflowTitle": "Skapa ert eget enkla arbetsflöde.",
    "workflowDescription": "Använd arbetsflöden för att hantera dina uppföljningar efter att kontakter har interagerat med detta formulär. Till exempel att skicka dem ett uppföljningsmail eller sms",
    "createWorkflow": "Skapa arbetsflöde",
    "workflowVisualAlt": "Visuellt arbetsflöde",
    "autoResponderSubheader": "Skicka ett automatiskt e-postmeddelande till personen som skickar in formuläret (e-postmeddelandet innehåller en kopia av den information som de angav i formuläret)",
    "replyToEmail": "Svarsmejl",
    "open": "Öppen",
    "won": "Vunnen",
    "lost": "Förlorad",
    "abandon": "Överge",
    "selectAPipeline": "Välj en pipeline",
    "stage": "Stadium",
    "status": "Status",
    "opportunityValue": "Möjlighetens värde",
    "createNewPipeline": "Skapa ny pipeline",
    "editOpportunitySettings": "Redigera möjlighetsinställningar",
    "contact": "Kontakt",
    "opportunity": "Möjlighet",
    "business": "Företag",
    "add": "Lägg till",
    "manage": "Hantera",
    "more": "Mer",
    "opportunityHeading": "Var vill du att din möjlighet ska uppdateras?",
    "date": {
      "dateSettings": "Datuminställningar",
      "dateFormat": "Datumformat",
      "dateSeparator": "Datumavdelare",
      "dateFormatTooltipMessage": "Välj ett datumformat. D står för dag, M för månader och Y för år",
      "dateSeparatorTooltipMessage": "Välj en avdelare som separerar dag, månad och år i det format som valts i Datumformat",
      "disablePicker": "Inaktivera väljare"
    },
    "dateTime": {
      "tabGeneral": "Allmänt",
      "tabFieldSettings": "Inställningar för fält",
      "collectHeading": "Välj vad det här fältet ska samla in",
      "collectDate": "Datum",
      "collectTime": "Tid",
      "collectDateTime": "Datum och tid",
      "collectTypeLockedTooltip": "Insamlingstypen kan endast ändras innan fältet sparas",
      "placeholderTextPlaceholder": "Lägg till platshållartext",
      "shortLabelPlaceholder": "Lägg till en kort etikett",
      "fieldSettingsBanner": "Definiera det tillåtna datum- eller tidsintervallet, begränsa vilka dagar användarna kan välja och välj hur värdet ska visas.",
      "allowedDateRange": "Tillåtet datumintervall",
      "dateModeAny": "Valfritt datum",
      "dateModeFuture": "Bara framtida datum",
      "dateModePast": "Endast tidigare datum",
      "dateModeRange": "Specifikt datumintervall",
      "futureQuestion": "Vilka datum kan användarna välja?",
      "futureAny": "Vilket som helst framtida datum",
      "futureAnyDesc": "Användare kan välja vilket datum som helst efter det aktuella datumet. T.ex., Boka ett möte när som helst nästa år.",
      "futureBuffer": "Efter bufferttid",
      "futureBufferDesc": "Användare kan endast välja datum efter ett fastställt antal dagar. T.ex., Tillåt bokningar 3 dagar från och med idag.",
      "futureBufferSuffix": "dagar från och med idag",
      "futureRolling": "Inom ett angivet datumintervall",
      "futureRollingDesc": "Användarna kan välja datum inom ett angivet framtida intervall. T.ex. Tillåt bokningar inom de kommande 30 dagarna.",
      "futureRollingPrefix": "Nästa",
      "futureRollingSuffix": "dagar",
      "rangeLabel": "Specifikt datumintervall",
      "rangeStart": "Startdatum",
      "rangeEnd": "Slutdatum",
      "availableDays": "Tillgängliga dagar",
      "allowedTimeRange": "Tillåtet tidsintervall",
      "timeModeAny": "När som helst",
      "timeModeRange": "Specifik tidsperiod",
      "timeRangeLabel": "Specifik tidsperiod",
      "timeStart": "Starttid",
      "timeEnd": "Sluttid",
      "timeFormatLabel": "Tidsformat",
      "timeFormat24": "24 timmar",
      "timeFormat12": "AM / PM",
      "timePlaceholder": "HH:MM",
      "defaultTimeLabel": "Standardtid",
      "defaultTimeHelper": "Förifyll med aktuell eller anpassad tid.",
      "defaultTimeNone": "Inget",
      "defaultTimeCurrent": "Nuvarande",
      "defaultTimeCustom": "Anpassad",
      "customTimeLabel": "Anpassad tid",
      "customTimeError": "Ange en giltig tid i formatet HH:MM",
      "disableCalendarPopup": "Inaktivera popup-meny för kalender",
      "meridianAm": "AM",
      "meridianPm": "PM",
      "daysError": "Vänligen välj minst en tillgänglig dag",
      "dateRangeError": "Slutdatum måste vara på eller efter startdatum",
      "timeRangeError": "Sluttiden måste vara efter starttiden",
      "saveBlockedTitle": "Datum- och tidsfältet är inte komplett",
      "saveBlockedDescription": "Åtgärda de markerade datum- och tidsvalideringsfelen innan ni sparar.",
      "weekday": {
        "mon": "mån",
        "tue": "tis",
        "wed": "ons",
        "thu": "tors",
        "fri": "fre",
        "sat": "lör",
        "sun": "sön"
      }
    },
    "restoreVersion": "Återställ version",
    "versionHistory": "Versionshistorik",
    "errorMessage": "Fel, försök igen",
    "version": "Version:",
    "currentVersion": "Nuvarande version",
    "messageStyling": "Meddelandeformat",
    "validateEmailHeader": "Validera e-post",
    "validateEmailDescription": "Knappen blir synlig när användaren anger sin e-postadress. Den här funktionen är utformad för att hjälpa dig att generera potentiella kunder av hög kvalitet.",
    "verifyEmail": "Verifiera e-postadress",
    "validatePhoneHeader": "Validera telefon",
    "validatePhoneDescription": "Knappen blir synlig när användaren anger sitt telefonnummer. Den här funktionen är utformad för att hjälpa dig att generera potentiella kunder av hög kvalitet.",
    "verifyPhone": "Verifiera telefonnummer",
    "validatePhoneWarning": "För att aktivera SMS OTP-verifiering behöver du se till att ditt telefonnummer är inställt i platsinställningarna",
    "addAnotherTnc": "Lägg till ytterligare regler och villkor",
    "tnc1": "T & C 1",
    "tnc2": "T & C 2",
    "deleteCaps": "DELETE",
    "deleteConfirmation": "Skriv DELETE för att bekräfta",
    "marginPadding": "Marginal och utfyllnad",
    "style": {
      "formLayoutType": "Formulärtyp",
      "layoutType": "Typ av layout",
      "surveyType": "Undersökningstyp",
      "oneColumn": "En kolumn",
      "twoColumn": "Två kolumner",
      "singleLine": "En rad",
      "fieldWidth": "Fältbredd",
      "labelAlignment": {
        "labelAlignment": "Etikettjustering",
        "labelWidth": "Etikettbredd"
      },
      "fieldSpacing": "Fältavstånd",
      "imageFieldSpacing": "Bild- och fältavstånd",
      "imageCornerRadius": "Hörnradie för bild",
      "color": "färg",
      "fontColor": "Typsnittsfärg",
      "inputBackgroundColor": "Bakgrundsfärg för inmatning",
      "inputBorder": "Feedback Kantlinje",
      "layout": "Layout",
      "colorsAndBackground": "Färger och bakgrund",
      "imageLayout": {
        "imageLayout": "Bildlayout",
        "showImage": "Visa bild",
        "image": "Bild",
        "desktop": {
          "topFixed": "Högsta Fixerad",
          "leftCenter": "Vänster Centrera",
          "rightCenter": "Höger Centrera",
          "leftFixed": "Fast till vänster",
          "rightFixed": "Höger Fixerad",
          "background": "Bakgrund"
        },
        "mobile": {
          "header": "Rubrik",
          "background": "Bakgrund"
        }
      },
      "focusPoint": {
        "title": "Fokuspunkt",
        "reset": "Återställ",
        "noImage": "Ingen bild har laddats upp"
      },
      "advanceSettings": "Avancerade Inställningar",
      "inputField": "Inmatningsfält",
      "borderWidth": "Kantlinjebredd",
      "borderColor": "Kantlinjefärg",
      "borderStyle": "Kantlinjestil",
      "fontSize": "Teckenstorlek",
      "fontWeight": "Typsnittstjocklek",
      "labelColor": "Etikettfärg",
      "placeholderColor": "Platshållarfärg",
      "shortLabelColor": "Färg på kort etikett"
    },
    "replyToTooltip": "Ange e-postadressen som svar på denna notifikation ska skickas till. Använd {'{'}{'{'}contact.email{'}'}{'}'} för att låta mottagare svara direkt till personen som har fyllt i formuläret.",
    "content": "Innehåll",
    "calculations": "Beräkningar",
    "uploadOptions": "Uppladdningsalternativ",
    "opportunitySettingsWarning": "Ange möjlighetsinställningar genom att klicka på knappen Redigera möjlighetsinställningar.",
    "startValue": "Startvärde",
    "endValue": "Slut",
    "today": "Idag",
    "thisWeek": "Den här veckan",
    "last7Days": "Senaste 7 dagarna",
    "thisMonth": "Den här månaden",
    "last30Days": "Senaste 30 dagarna",
    "question": "Fråga",
    "createContactOnPartialSubmission": "Skapa kontakt vid partiell inlämning",
    "howItWorks": "Hur fungerar det?",
    "createContactOnPartialSubmissionDescription": "Slutför bilden och klicka på ”Nästa”. En ny kontakt skapas och lagras automatiskt.",
    "swapWarningMessageSurvey": "Om alternativ redigeras eller byts ut påverkas det anpassade fältet på alla platser där fältet används. Det kan också återställa villkorlig logik. ",
    "swapWarningMessageForm": "Om alternativ redigeras eller byts ut påverkas det anpassade fältet på alla platser där fältet används. ",
    "migrationWarningMessage": "Funktionen har migrerats till villkorlig logik för undersökningar.",
    "optionLabel": "Alternativetikett",
    "calculationValue": "Beräkningsvärde",
    "addOption": "Lägg till alternativ",
    "addOtherOption": "Lägg till alternativet ”Annat”",
    "otherOptionLabel": "Annat",
    "otherOptionPlaceholder": "Vänligen skriv in ett annat alternativ här",
    "enableCalculations": "Aktivera beräkningar",
    "allowOtherOption": "Tillåt annat alternativ",
    "productSelectionSubtext": "Aktivera Individ Eller urval av flera produkter",
    "multi": "Flera",
    "single": "Individ",
    "productSelectionHeading": "Produkt",
    "spreadToColumns": "Fördela till kolumner",
    "columns": "Kolumner",
    "customstyle": "Stil",
    "standard": "Standard",
    "bubble": "Bubbla",
    "radioStyles": {
      "standardAlt": "Standard radiostil",
      "bubbleAlt": "Bubble-stil för ettvalsknapp"
    },
    "data": "Data",
    "integratePopup": {
      "title": "Integrera formulär",
      "embedCode": "Bädda in kod",
      "useInFunnelOrEmbedCode": "Använd i tratt/inbäddningskod",
      "iframeEmbed": "Inbäddad iframe",
      "layout": {
        "title": "Typ av inbäddningslayout",
        "description": "Välj en layout för att bädda in i en tratt eller extern webbplats",
        "allowMinimize": "Tillåt minimering",
        "minimizedTitlePlaceholder": "Minimerad titel",
        "leftAlignAlt": "Vänsterjustera",
        "rightAlignAlt": "Högerjustera"
      },
      "triggerType": "Utlösartyp",
      "triggers": {
        "seconds": "sekunder"
      },
      "activation": {
        "title": "Aktiveringsalternativ",
        "visit": "besök"
      },
      "deactivation": {
        "title": "Inaktiveringsalternativ",
        "times": "gånger"
      },
      "copyEmbedCode": "Kopiera inbäddningskod",
      "copyFormLink": "Kopiera formulärlänk",
      "openFormLink": "Öppna formulärlänk",
      "invalidInput": "Ogiltig inmatning!",
      "funnel": {
        "funnel": "Tratt",
        "chooseStep": "Välj a Steg",
        "copyCodeAndOpenFunnel": "Kopiera Kod och Öppna Tratt"
      },
      "share": {
        "share": "Dela",
        "shareViaSocials": "Dela Via Sociala medier",
        "copyLink": "Kopiera länk"
      },
      "email": {
        "email": "E-post",
        "shareViaEmail": "Dela Via E-post",
        "emailButton": "E-post",
        "blankTemplate": "Tom Mall",
        "emailMarketingTemplates": "Mallar för E-post Marknadsföring",
        "or": "Eller",
        "chooseTemplate": "Välj bland dina mallar",
        "continue": "Fortsätt"
      }
    },
    "rating": {
      "icon": "Ikon",
      "iconAlignment": "Ikon Orientering",
      "count": "Antal",
      "lowestRating": "Min Betyg",
      "highestRating": "Max",
      "iconSelectedState": "Ikon Markerad Delstat",
      "iconUnselectedState": "Ikon Avmarkerat Delstat",
      "rating": "Betyg",
      "ratingSettings": "Betyg Inställningar",
      "calculationType": {
        "calculationType": "Hur man Arkivera Betyg Fält in Anpassad Fält",
        "calculationTypeTooltip": "När Du Frekvens något 4 Från 5 stjärnor betyder det: - Absolut: 4 från 5 - Procentsats: 80 - Bråk: 0,8",
        "absolute": "Absolut",
        "percentage": "Procentsats",
        "fraction": "Bråk"
      }
    },
    "desktopMode": "Datorläge",
    "mobileMode": "Mobilläge",
    "versions": "Varianter",
    "advanced": "Avancerat",
    "edit": "Redigera",
    "settings": "Inställningar",
    "submissions": "Inlämningar",
    "analytics": "Analys",
    "notifications": "Aviseringar",
    "undo": "Ångra",
    "redo": "Gör om",
    "customValues": "Anpassade värden",
    "pickBgFromImage": "Gör bakgrunden i meddelandefältet suddig. Om du väljer en bakgrundsfärg för meddelandefältet visas den ovanpå det suddiga meddelandefältet.",
    "pickBgFromImageTip": "Väljer en Färg med hög Jämför för BG-Bilden. Meddelande: Används inte om Formulär Bakgrunden inte har någon Bild",
    "messageBackgroundBlur": "Bakgrundsoskärpa",
    "confirmationMessage": "Bekräftelsemeddelande",
    "deleteOption": "Alternativ för Radera",
    "deleteConfirmationModal": {
      "defaultDescription": "Raderar ett alternativ kommer att påverka detta Anpassad-fält över varje Platser där fältet används. Är du säker på att du vill Radera det?",
      "validationMessage": "Vänligen ange Radera till Spara.",
      "validationError": "Vänligen ange Radera"
    },
    "disqualifyImmediately": "Diskvalificera omedelbart",
    "disqualifyAfterSubmit": "Diskvalificera efter inlämning",
    "generalSettings": "Allmän Inställningar",
    "advancedSettings": "Avancerade Inställningar",
    "customFieldName": "Anpassad Bransch Namn",
    "customFieldNameTooltip": "Denna Bransch Namn är unik per Anpassad Bransch.",
    "customFieldNameTooltipContact": "Dessa fält möjliggör för användare att samla in ytterligare detaljer om en person, såsom deras leadtyp, födelsedag eller föredragen kontaktmetod.",
    "customFieldNameTooltipContactLearnMore": "Mer information",
    "customFieldNameTooltipOpportunity": "Dessa fält används för att spåra avtalsspecifik data för varje affärsmöjlighet, inklusive information som budget eller ett avslutsmål.",
    "customFieldNameTooltipOpportunityLearnMore": "Mer information",
    "customFieldNameTooltipCompany": "Dessa fält möjliggör insamling av information på organisationsnivå (t.ex. för leverantörer, kunder eller byråer) som är kopplad till kontakter.",
    "customFieldNameTooltipCompanyLearnMore": "Mer information",
    "customFieldNameTooltipCustomObject": "Dessa fält möjliggör för användare att samla in företagsspecifik data, såsom detaljer om tillgångar, fordon eller fastigheter, och integrera denna information i deras CRM-system.",
    "customFieldNameTooltipCustomObjectLearnMore": "Mer information",
    "uniqueKey": "Unik nyckel",
    "uniqueKeyTooltip": "Denna nyckel är systemidentifieraren för det anpassade fältet. När den väl är inställd kan det inte ändras.",
    "uniqueKeyTooltipLearnMore": "Mer information",
    "selectContactAssociation": "Klicka på relationen med Kontakter",
    "associations": "Associationer",
    "createNewAssociation": "Skapa ny association",
    "selectAnAssociation": "Välj en association",
    "loadingAssociations": "Läser in associationer...",
    "unknownAssociation": "Okänd Förening",
    "manyToMany": "Många till många",
    "failedToLoadAssociations": "Misslyckades med att läsa in associationer.",
    "noAssociationsFound": "Inga associationer hittades",
    "keepThisField": "Behåll det här fältet",
    "association": "Association",
    "customObject": "Anpassat objekt",
    "customObjects": "Anpassade objekt",
    "object": "Objekt",
    "editAssociation": "Redigera {objectName} association",
    "editAssociationButton": "{edit} {objectName} {association}",
    "fields": "Fält",
    "primaryFieldWarning": "{fieldName} är ett PRIMÄR fält för {objectSingular} och Krävs för att skapa Eller Uppdatera en {objectSingular}.",
    "primaryFieldTitle": "{fieldName} krävs för att skapa eller uppdatera {objectSingular} -posten.",
    "removeAllFields": "Rensa alla {objectSingular} Fält",
    "customObjectsFallback": "Anpassade objekt",
    "noneAssociation": "Ingen",
    "noneAssociationDescription": "Ingen Relation till Kontakter (inga Kontaktfält finns)",
    "survey": {
      "layoutType": "Undersökningstyp",
      "oneQuestionPerPage": "En fråga i taget",
      "allQuestionsOnePage": "Många i taget"
    },
    "quizQuestions": "Quiz Fråga",
    "choiceElements": "Choice Komponenter",
    "otherElements": "Annan Komponenter",
    "listEditor": {
      "prefillValueHeader": "Värde för Fyll i på förhand",
      "labelPlaceholder": "Etikett",
      "valuePlaceholder": "Värde",
      "optionRequiredError": "Alternativet Fält är Krävs"
    },
    "field": "Fält",
    "scoreEditor": {
      "addFieldPlaceholder": "Lägg till Fält",
      "fieldLabel": "Fält",
      "numberLabel": "siffra"
    },
    "fileUploadEditor": {
      "fileTypes": "Fil",
      "all": "varje",
      "pdf": "PDF",
      "docxDoc": "DOCX/DOC",
      "png": "PNG",
      "gif": "GIF",
      "jpgJpeg": "JPG/JPEG",
      "xlsCsv": "XLS/CSV"
    },
    "ok": "Ok",
    "allowMultipleFiles": "Aktivera Multiple Filer",
    "maxFileLimit": "Max Fil",
    "privacyPolicy": "Sekretesspolicy",
    "termsOfService": "Villkor för tjänsten",
    "colorPicker": {
      "brandColors": "Varumärkesfärger",
      "defaultColors": "Standardfärger",
      "globalCustomColors": "Globala anpassade färger"
    },
    "billingFrequency": "Faktureringsfrekvens",
    "otherAmount": "Annat belopp",
    "exampleUrlPlaceholder": "https://www.exempel.com",
    "checkboxStyles": {
      "standardAlt": "Standardstil för kryssruta",
      "bubbleAlt": "Bubble-stil för kryssruta"
    },
    "previewIcons": {
      "exportAlt": "Exportikon",
      "shipmentAlt": "Leveransikon",
      "resultAlt": "Ikon för resultatsida"
    },
    "examples": {
      "sampleUrl": "https://exempel.com"
    },
    "showing": "Visning",
    "of": "av",
    "enterCouponCode": "Ange kupongkod",
    "apply": "Tillämpa",
    "paymentWillBeProcessed": "Betalningen kommer att behandlas så snart ni går vidare till nästa steg",
    "paymentWillBeProcessedNextSlide": "Betalningen kommer att behandlas så snart användaren går vidare till nästa bild",
    "showThisAlertToUsers": "Visa den här varningen för användarna",
    "sixteenDigitCardNumber": "16-siffrigt kortnummer",
    "mmYy": "MM/ÅÅ",
    "cvc": "CVC",
    "threeDigitCode": "3-siffrig kod",
    "enterCardNumber": "Ange kortnummer",
    "pleaseFillRequiredFields": "Fyll i alla obligatoriska fält!",
    "opportunitySettingsIncomplete": "Inställningarna för affärsmöjligheterna är ofullständiga",
    "opportunitySettingsIncompleteDescription": "Det här formuläret innehåller fält för affärsmöjligheter, men inställningarna för affärsmöjligheter har inte uppdaterats. Konfigurera inställningarna för affärsmöjligheter för att kunna spara formuläret.",
    "ariaAttributes": {
      "iconSearch": "Ikonsök"
    },
    "alt": {
      "standardRadioStyle": "Standardstil för alternativknapp",
      "bubbleRadioStyle": "Bubble-stil för alternativknapp"
    },
    "value": "Värde",
    "jumpTo": "Hoppa till",
    "thankYouJohnDoe": "Tack, John Doe",
    "total": "Totalt",
    "urlExamples": {
      "simple": "example.com",
      "https": "https://exempel.com",
      "withPath": "example.com/path",
      "fullPath": "https://www.example.com/path"
    },
    "quizThankYou": "Tack för att du tog dig tid att slutföra quizet."
  },
  "overallScore": {
    "defaultTitle": "Totalpoäng"
  },
  "fields": {
    "quizQuestions": {
      "singleChoice": "Individuellt val",
      "multipleChoice": "Flervalsalternativ",
      "yesNo": "Ja / Nej",
      "shortAnswer": "Kort textsvar",
      "longAnswer": "Långt svar",
      "number": "siffra",
      "singleDropdown": "Individuell Rullgardinsmeny",
      "multiDropdown": "Flera Rullgardinsmeny"
    },
    "personal": {
      "fullName": "Fullständigt namn",
      "firstName": "Förnamn",
      "lastName": "Efternamn",
      "dateOfBirth": "Födelsedatum",
      "phone": "Telefon",
      "email": "E-postadress",
      "fullNamePlaceholder": "Ange ditt fullständiga namn",
      "firstNamePlaceholder": "Ange ditt förnamn",
      "lastNamePlaceholder": "Ange ditt efternamn",
      "dateOfBirthPlaceholder": "DD/MM/ÅÅÅÅ",
      "phonePlaceholder": "+1 (555) 000-0000"
    },
    "submit": {
      "button": "Knapp"
    },
    "integration": {
      "sellProducts": "Sälj produkter",
      "collectPayment": "Ta emot Utbetalning"
    },
    "address": {
      "address": "Adress",
      "streetAddress": "Adress",
      "city": "Stad",
      "state": "Region",
      "country": "Land",
      "postalCode": "Postnummer",
      "organization": "Grupp",
      "website": "Webbplats",
      "websitePlaceholder": "https://yourwebsite.com",
      "addressPlaceholder": "Gatuadress",
      "streetAddressPlaceholder": "Ange din fullständiga adress",
      "cityPlaceholder": "Ange din stad",
      "statePlaceholder": "Ange din delstat",
      "countryPlaceholder": "Ange ert land",
      "postalCodePlaceholder": "Postnummer",
      "organizationPlaceholder": "Ange er organisation"
    },
    "text": {
      "singleLine": "Enskild Linje",
      "multiLine": "Flera Linje",
      "textBoxList": "SMS:a Fyrkant Lista",
      "singleLinePlaceholder": "Ange din text",
      "multiLinePlaceholder": "Skriv ditt meddelande här"
    },
    "choiceElements": {
      "singleDropdown": "Individuell Rullgardinsmeny",
      "multiDropdown": "Flera Rullgardinsmeny",
      "checkbox": "Kryssruta",
      "radio": "Alternativknapp",
      "singleDropdownPlaceholder": "Välj ett alternativ",
      "multiDropdownPlaceholder": "Välj ett eller flera alternativ",
      "pictureChoice": {
        "label": "Bildval",
        "multipleSelection": "Flera val",
        "selectionTypeLocked": "Valtyp kan inte ändras efter att detta anpassade fält har sparats.",
        "imageRequiredBeforeSave": "Varje alternativ i ett Picture Choice-element måste ha en bild.",
        "labelRequiredBeforeSave": "Varje alternativ i ett Picture Choice-element måste ha en etikett.",
        "duplicateOptionLabelsBeforeSave": "Varje alternativ i ett Picture Choice-element måste ha en unik etikett.",
        "selectionLimitInvalidBeforeSave": "Ange en giltig urvalsgräns för Bildval-elementet.",
        "selectionLimit": "Urvalsgräns",
        "unlimited": "Obegränsat",
        "exact": "Exakt",
        "range": "Räckvidd",
        "exactSelections": "Exakta val",
        "minimum": "Minimum",
        "maximum": "Maximalt",
        "options": "Alternativ",
        "optionSettings": "Alternativinställningar",
        "showOptionLabel": "Visa alternativetikett",
        "addOption": "Lägg till alternativ",
        "otherOption": "Alternativet 'Annat'",
        "imageFit": "Bildanpassning",
        "cover": "Omslagsbild",
        "contain": "Innehåller",
        "fill": "Fyllnad",
        "spreadToColumns": "Fördela till kolumner",
        "columns": "Kolumner",
        "numberOfColumns": "Antal kolumner",
        "desktopColumnsLimit": "Högst {count} kolumner på dator.",
        "mobileColumnsLimit": "Högst {count} kolumner på mobil.",
        "otherOptionLabel": "Annan alternativetikett",
        "optionLabel": "Alternativetikett",
        "image": "Bild",
        "media": "Media",
        "otherImageUploadUnavailable": "Det går inte att ladda upp en bild för alternativet Annat.",
        "removeImage": "Ta bort bild",
        "deleteOption": "Radera alternativ",
        "altText": "Alt-text"
      }
    },
    "customized": {
      "text": "SMS:a",
      "html": "Html",
      "htmlPlaceholder": "Den Anpassad HTML-koden finns här",
      "captcha": "Captcha",
      "captchaDefaultLabel": "Utmaning",
      "botProtection": "Botskydd",
      "verificationMode": "Verifieringsläge",
      "interactive": "Interaktiv",
      "invisible": "Osynlig",
      "invisibleModeDescription": "Denna verifiering körs automatiskt i bakgrunden och kommer inte att vara synlig för användarna",
      "fieldHiddenWarning": "Detta fält är dolt och kommer inte att synas i formuläret.",
      "verifyHuman": "Verifiera att ni är människa",
      "privacy": "Integritet",
      "help": "Hjälp",
      "captchaPlaceholder": "CAPTCHA",
      "source": "Källa",
      "termsAndConditions": "T & C",
      "termsAndConditionsPlaceholder": "Jag godkänner villkoren Utfärdade Via företaget. Via att uppge mitt telefonnummer godkänner jag Ärv SMS:a-meddelanden Från företaget.",
      "score": "Poäng",
      "scorePlaceholder": "T.ex.: Din poäng är 100 %"
    },
    "other": {
      "url": "URL",
      "urlPlaceholder": "Ange en URL",
      "image": "Bild",
      "fileUpload": "Fil Ladda upp",
      "monetary": "Monetärt",
      "number": "siffra",
      "datePicker": "Datum och tid",
      "datePickerLegacy": "Datumväljare",
      "datePickerGeneratedName": "Datum",
      "timePickerGeneratedName": "Tid",
      "dateTimePickerGeneratedName": "Datum och tid",
      "signature": "Signatur",
      "monetaryPlaceholder": "Ange belopp",
      "signaturePlaceholder": "Skriv under här",
      "numberPlaceholder": "Ange ett nummer",
      "datePickerPlaceholder": "DD/MM/ÅÅÅÅ",
      "imageUploadPlaceholder": "Ingen bild har lagts till ännu",
      "imageUploadSubText": "Ladda upp till Media Storage eller dra och släpp",
      "imageUploadButtonText": "Ladda upp foto",
      "fileText": "Fil",
      "fileUploadSupportedFileTypes": "PDF, DOC/DOCX, XLS/CSV, JPG/JPEG, PNG, GIF",
      "fileUploadPlaceholder": "Klicka för att ladda upp"
    },
    "customstyle": "Stil",
    "standard": "Standard",
    "bubble": "Bubbla"
  },
  "survey": {
    "addSlideText": "Lägg till element",
    "defaultScreenTitle": "Dra och släpp komponenter",
    "defaultScreenDescription": "Flytta din fråga till sidan {pageIndex} med hjälp av elementen till vänster.",
    "typeOfBuilder": "Undersökning",
    "survyeStyle": "Undersökningsstil",
    "surveyName": "Undersökningsnamn",
    "surveyElement": "Undersökningselement",
    "addSurveyElement": "Lägg till undersökningselement",
    "cloneSlide": "Klona Bild",
    "unsavedAlertMessage": "Undersökningen har arbete som inte har sparats. Är du säker på att du vill lämna och kasta allt osparat arbete?",
    "thirdPartyScriptAlertMessage": "Tredjepartsskript inuti HTML-blocket kan ge effektiva funktioner men de medför också risker för integritet, säkerhet, prestanda och sidbeteende. Därför rekommenderar vi att du granskar innehållet i det här skriptet innan du sparar det i undersökningen.",
    "integrateHeader": "Integrera undersökning",
    "integrateSubHeader": "Använd följande alternativ för att integrera din anpassade undersökning på en webbplats",
    "integrateCopyLinkMessage": "Kopiera länken nedan och dela den enkelt var du vill.",
    "onSurveySubmission": "Vid undersökningsinlämning",
    "saveExitConfirmation": "Spara framsteg för enkäter",
    "surveySettings": "Undersökningsinställningar",
    "oneQuestionAtTime": "En fråga i taget",
    "backButton": "Tillbaka-knapp",
    "backButtonTooltipMessage": "Tillbaka-knappen hjälper användarna att gå till föregående bild",
    "disableAutoNavigation": "Inaktivera automatisk navigering",
    "disableAutoNavigationTooltipMessage": "Navigerar automatiskt till Nästa Skjut Efter a Användare svarar.",
    "autoNavigation": "Auto navigering",
    "autoNavigationTooltipMessage": "Navigerar automatiskt till Nästa Skjut Efter a Användare svarar.",
    "progressBar": "Förloppsfält",
    "progressBarTooltipMessage": "Om du stänger av detta tas förloppsfältet bort från undersökningen",
    "disableAnimation": "Inaktivera animation",
    "disableAnimationTooltipMessage": "Om du aktiverar det här inaktiveras animationen för bildövergångar",
    "scrollToTop": "Skrolla till toppen",
    "scrollToTopTooltipMessage": "Om det är aktiverat skrollas undersökningen till toppen på nästa bild",
    "submitSurvey": "Skicka in undersökningen",
    "disqualifyImmediately": "Diskvalificera omedelbart",
    "disqualifyAfterSubmit": "Diskvalificera efter inlämning",
    "disqualifyAfterSubmitLowerCase": "Diskvalificera efter inlämning",
    "footerHTML": "HTML för sidfot",
    "footerHTMLMessage": "Du kan skriva anpassad CSS (med hjälp av stiltaggar) och HTML i samma ruta",
    "editFooter": "Redigera sidfot",
    "disqualifySettings": "Inställningar för diskvalificering",
    "disqualifyImmediatelyLabel": "Omedelbart",
    "disqualifyAfterSubmitLabel": "Efter att ha skickat in",
    "slideConflictAlertMessage": "Den här bilden innehåller flera frågor med inställd logik. Detta kan orsaka oavsiktligt beteende",
    "addSlide": "Lägg till bild",
    "settings": "Inställningar",
    "delete": "Radera",
    "slideDeleteAlertMessage": "Är du säker på att du vill ta bort den här bilden?",
    "slideDeleteBetweenAlertMessage": "Detta kommer att omorganisera de andra bilderna. Är du säker på att du vill ta bort den här bilden?",
    "slideLabel": "Bild {n}",
    "slideName": "Bildens namn",
    "slidePosition": "Bildens placering",
    "jumpTo": "Hoppa till",
    "jumpToSubText": "Hoppa till en specifik bild",
    "enableTimezoneSurvey": "Om du aktiverar det här alternativet registreras information om tidszon för den person som skickar in undersökningen",
    "footer": {
      "footer": "Sidfot",
      "enableNewFooter": "Aktivera ny sidfot",
      "stickToSurvey": " Fäst till undersökning",
      "backgroundFill": "Bakgrundsfyllnad",
      "footerHeight": "Sidfotshöjd",
      "enableProgressBar": "Aktivera förloppsindikator",
      "buttons": "Knappar",
      "button": "Knapp",
      "buttonType": "Knapptyp",
      "buttonTypeTooltip": "Välj hur navigeringsknapparna ska visas i sidfoten på din undersökning",
      "fillNext": "Fyll (nästa)",
      "fillPrevious": "Fyll (föregående)",
      "fillSubmit": "Fyll i (skicka)",
      "textColor": "Knapptext",
      "position": "Position",
      "positionTooltip": "Välj hur navigeringsknapparna ska visas i sidfoten på din undersökning",
      "previousText": "Föregående (text)",
      "nextText": "Nästa (text)",
      "submitText": "Skicka (text)",
      "fillComplete": "Fyllning vid komplett",
      "fillInactive": "Fyllning vid inaktiv",
      "footerType": "Sidfotstyp",
      "stickToCard": "Håll dig till kortet",
      "stickToPage": "Håll dig till sidan",
      "stepTextColor": "Steg Brödtext Färg",
      "progressBarFill": "Förloppsfält Fyll",
      "progressBarInactive": "Förloppsfält Inaktiv",
      "arrowFill": "Fyll med Pil",
      "submitColorMobile": "Skicka (Färg)",
      "arrowFillColor": "Pil Fyll Färg",
      "buttonTypes": {
        "textAndArrow": "Text och pil",
        "onlyText": "Bara text",
        "onlyArrow": "Endast Arrow"
      },
      "positions": {
        "leftAndRight": "Vänster & Höger"
      },
      "placeholders": {
        "prev": "Föreg.",
        "next": "Nästa",
        "submit": "Skicka"
      }
    },
    "surveyNotfication": "Undersökningsavisering",
    "style": {
      "surveyPadding": "Undersökningsutfyllnad"
    },
    "integratePopup": {
      "shareOrEmbed": "Bädda in eller dela undersökning",
      "share": {
        "openFormLink": "Öppna Undersökning Länk"
      },
      "email": {
        "emailSubheader": "Skapa ett tomt E-inlägg och Inbäddad din Undersökning, Eller Välj a Mall och Inbäddad it Omedelbart."
      }
    },
    "autoResponderSubheader": "Skicka ett automatiskt e-postmeddelande till personen som skickar in undersökningen (e-postmeddelandet innehåller en kopia av den information som de angav i undersökningen)",
    "sendSubmissionsAsPdf": "Skicka inlämnad undersökning som en PDF",
    "switchToOneQuestionAtTimeOn": "Om du aktiverar ”En fråga vid ett datum” störs din Nuvarande villkorliga Logik",
    "switchToOneQuestionAtTimeOff": "Inaktivera ”En fråga vid ett datum” påverkar din villkorliga Logik Config",
    "switchToOneQuestionAtTimeOnWarning": "Vissa villkor kommer inte längre att fungera som förväntat När-frågor är Deltog one at a Datum.",
    "switchToOneQuestionAtTimeOffWarning": " Vissa villkor avsedda för individuell fråga Flöde slutar fungera som avsett.",
    "createContactOnPartialSubmissionSubText": "Skapar en kontakt när en användare klickar på ”Nästa” på en bild – även om hen inte slutför undersökningen.",
    "dragDrop": {
      "imageLabel": "Bild {n}",
      "htmlLabel": "HTML {n}",
      "defaultFolderName": "Undersökning {'|'} {name}",
      "defaultTermsHtml": "<p style=\"text-align: center\"><a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Integritetspolicy</a> | <a target=\"_blank\" rel=\"noopener noreferrer nofollow\" href=\"https://www.example.com\">Användarvillkor</a></p>",
      "smsConsent": "Jag samtycker till att ta emot SMS-aviseringar, varningar och enstaka marknadsföringsmeddelanden från företaget. Meddelandenas frekvens varierar. Meddelande- och dataavgifter kan tillkomma. Sms:a HJÄLP till (XXX) XXX-XXXX för att få hjälp. Du kan när som helst svara STOPP för att sluta prenumerera."
    }
  },
  "form": {
    "typeOfBuilder": "Formulär",
    "formStyle": "Formulärstil",
    "formElement": "Formulärelement",
    "addFormElement": "Lägg till formulärelement",
    "addConditionalLogic": "Lägg till villkorlig logik",
    "openConditionalLogic": "Öppna villkorlig logik",
    "inlineForm": "Infogat formulär",
    "formName": "Formulärnamn",
    "fullScreenMode": "Fullskärmsläge",
    "fullScreenModetooltip": "Om du aktiverar det kommer formuläret att expanderas över hela behållarens bredd och sträcka sig till kanten av inbäddningsområdet samtidigt som det följer formulärets bredd.",
    "enableTimezoneForm": "Om du aktiverar det här alternativet registreras information om tidszon för den person som skickar in formuläret",
    "formSettings": "Formulärinställningar",
    "scheduleVisibility": {
      "title": "Synlighet för {product}",
      "subtitle": "Ange när den här {product} ska börja och sluta ta emot svar. Utanför det här fönstret kommer besökare att se meddelandena du konfigurerar nedan.",
      "formOpens": "{Product} öppnar",
      "formCloses": "{Product} stänger",
      "rightAway": "Omedelbart",
      "never": "Aldrig",
      "pickADate": "Välj ett datum",
      "opensPlaceholder": "Öppnas så snart du publicerar",
      "closesPlaceholder": "Förblir öppen tills du stänger den",
      "date": "Datum",
      "time": "Tid",
      "timezone": "Tidszon",
      "timezoneHelp": "Gäller för både öppnings- och stängningstider.",
      "timezonePlaceholder": "Välj en tidszon",
      "timeline": {
        "notOpenYet": "Inte öppet än",
        "acceptingResponses": "Tar emot svar",
        "closed": "Stängd",
        "current": "Nuvarande",
        "opens": "Öppnar",
        "closes": "Stänger"
      },
      "whatVisitorsSee": "Vad besökare ser",
      "whatVisitorsSeeHelp": "De här sidorna visas bara utanför det öppna tidsintervallet. Välj ett läge för att konfigurera det.",
      "states": {
        "beforeTitle": "Innan {product} öppnar",
        "afterTitle": "När {product} stängs",
        "showsPage": "Visar en anpassad sida",
        "redirectsTo": "Omdirigerar till {url}"
      },
      "showPage": "Visa en sida",
      "showPageHelp": "Designa vad besökare ser.",
      "openLink": "Öppna en länk",
      "openLinkHelp": "Skicka dem till en annan URL.",
      "redirectUrl": "URL för omdirigering",
      "redirectUrlPlaceholder": "https://exempel.com",
      "redirectUrlHelp": "Besökare i det här läget skickas hit istället för att se en sida. Använd en fullständig URL, till exempel https://example.com/path.",
      "redirectUrlInvalid": "Ange en giltig URL som börjar med http:// eller https://, till exempel https://example.com/path.",
      "defaultBeforeMessage": "Denna {product} är inte öppen ännu",
      "defaultAfterMessage": "Den här {product} är nu stängd.",
      "defaultBeforeBody": "Den här {product} en tar inte emot svar än. Kom tillbaka när det har öppnat för att skicka in ditt svar.",
      "defaultAfterBody": "Tack för ditt intresse! Denna {product} har slutat ta emot svar. Kontakta {product} -ägaren om du fortfarande behöver kontakta oss.",
      "closeAfterOpenError": "Stängningstiden måste vara efter öppettiden.",
      "preview": {
        "label": "Förhandsgranska",
        "labelHint": "– så här ser det ut för besökare",
        "redirectTo": "Du omdirigeras till:",
        "poweredBy": "Drivs av din byrå"
      },
      "appearance": {
        "title": "Utseende",
        "cardBackground": "Kortbakgrund",
        "pageBackground": "Sidans bakgrund",
        "cornerRadius": "Hörnradie",
        "cardWidth": "Kortets bredd",
        "cardHeight": "Kortets höjd",
        "shadow": "Skugga",
        "autoPlaceholder": "Auto",
        "marginPadding": "Marginal och utfyllnad",
        "auto": "automatisk",
        "miscellaneous": "Övrigt",
        "agencyBranding": "Byråns varumärke",
        "agencyBrandingHelp": "Visa byråns logotyp och namn på sidor i stängt läge.",
        "shadowOptions": {
          "none": "Inget",
          "soft": "Mjuk",
          "elevated": "Förhöjd"
        },
        "colors": {
          "default": "Standard",
          "lightGray": "Ljusgrå",
          "brandTint": "Varumärkesfärg",
          "blush": "Puderrosa",
          "dark": "Mörk",
          "white": "Vit",
          "coolGray": "Blågrå"
        }
      }
    },
    "saveExitConfirmation": "Spara framsteg för formulär",
    "unsavedAlertMessage": "Formuläret har arbete som inte har sparats. Är du säker på att du vill lämna och kasta allt osparat arbete?",
    "thirdPartyScriptAlertMessage": "Tredjepartsskript inuti HTML-blocket kan ge effektiva funktioner men de medför också risker för integritet, säkerhet, prestanda och sidbeteende. Därför rekommenderar vi att du granskar innehållet i det här skriptet innan du sparar det i formuläret.",
    "onFormSubmission": "Vid formulärinlämning",
    "integrateForm": "Integrera formulär",
    "embedlayoutType": "Inbäddad Layout Typ",
    "embedlayoutTypeSubMessage": "Välj en layout för att bädda in i en tratt eller extern webbplats",
    "triggerType": "Utlösartyp",
    "showOnScrolling": "Visa vid skrollning",
    "showAfter": "Visa efter",
    "seconds": "sekunder",
    "alwaysShow": "Visa alltid",
    "activationOptions": "Aktiveringsalternativ",
    "activateOn": "Aktivera vid",
    "visit": "besök",
    "alwaysActivated": "Alltid aktiverad",
    "deactivationOptions": "Inaktiveringsalternativ",
    "deactivateAfterShowing": "Inaktivera efter visning",
    "times": "gånger",
    "deactiveOnceLeadCollected": "Inaktivera när potentiell kund har registrerats",
    "neverDeactivate": "Inaktivera aldrig",
    "copyEmbedCode": "Kopiera inbäddningskod",
    "copyFormLink": "Kopiera formulärlänk",
    "openFormLink": "Öppna formulärlänk",
    "inline": "Infogat",
    "inlineDescription": "Ett infogat formulär visas tillsammans med innehållet på sidan som ett inbyggt element. Den ligger inte ovanpå sidan och kan inte stängas eller minimeras.",
    "inlineHoverDescription": "Ett infogat formulär visas tillsammans med innehållet på sidan som ett inbyggt element. Den ligger inte ovanpå sidan och kan inte stängas eller minimeras.",
    "popup": "Popup",
    "popupDescription": "Ett popup-fönster visar formulär som ett överlägg inuti ett fönster. Det kan inte minimeras utan måste stängas.",
    "popupHoverDescription": "Ett popup-fönster visar formulär som ett överlägg inuti ett fönster. Det kan inte minimeras utan måste stängas.",
    "politeSlideIn": "Artigt insegel",
    "politeSlideInDescription": "Ett artigt insegel visas längst ned på skärmen och försvinner när det stängs",
    "politeSlideInHoverDescription": "Visas på skärmens undersida och försvinner när den stängs",
    "stickySidebar": "Fäst sidofält",
    "stickySidebarDescription": "Ett fäst sidofält visas på sidan av skärmen och kan minimeras till en flik som fästs vid sidan av fönstret",
    "stickySidebarHoverDescription": "Visas på sidan av skärmen och kan minimeras till en flik som fästs vid sidan av fönstret",
    "allowMinimize": "Tillåt minimering",
    "checkForCookieConsent": "Respektera värdwebbplatsens cookiesamtycke",
    "checkForCookieConsentTooltip": "Pixelhändelser utlöses endast efter att besökaren har godkänt marknadsföringscookies på den webbplats där det här formuläret är inbäddat. Automatisk identifiering söker efter GHL-CookieConsent, OneTrust, Cookiebot, Complianz, Usercentrics, TrustArc, Cookieyes, Iubenda, Termly, Osano, Didomi och IAB TCF.",
    "cookieConsentProvider": "Leverantör av cookiesamtycke",
    "cookieConsentProviderPlaceholder": "Välj banner för cookiesamtycke",
    "cookieConsentProviderAutoDetect": "Upptäck automatiskt",
    "modalHeight": "Modalhöjd",
    "modalHeightPlaceholder": "Ange modalens höjd",
    "conditonalLogic": {
      "conditions": "Villkor",
      "noExistingCondition": "Inga befintliga villkor än",
      "freeRoamMessage": "Du kan ströva fritt utan reglerna – för tillfället i alla fall",
      "addNewCondition": "Lägg till nytt villkor",
      "redirectToUrl": "Omdirigera till URL",
      "displayCustomMessage": "Visa anpassat meddelande",
      "disqualifyLead": "Diskvalificera potentiell kund",
      "showHideFields": "Visa/dölj fält",
      "jumpTo": "Hoppa till",
      "redirectToUrlSubText": "Omdirigera Användare efter inlämning",
      "displayCustomMessageSubText": "Visa-meddelanden baserade På Användare-ingångar",
      "disqualifyLeadSubText": "Filtrera bort poster under specifika förhållanden",
      "showHideFieldsSubText": "Ändra Fält Synlighet dynamiskt",
      "openBelowUrl": "Öppna nedanstående URL",
      "showCustomMessage": "Visa anpassat meddelande",
      "alertConditionDelete": "Är du säker på att du vill ta bort det här villkoret?",
      "deleteCondition": "Ta bort villkor",
      "conditionExecutedMessage": "Villkoren kommer att exekveras uppifrån och ned.",
      "allOperationOptions": {
        "isEqualTo": "Är lika med",
        "isNotEqualTo": "Är inte lika med",
        "contains": "Innehåller",
        "doesNotContain": "Innehåller inte",
        "startsWith": "Börjar med",
        "endsWith": "Slutar med",
        "isEmpty": "Är tom",
        "isFilled": "Är fylld",
        "before": "Före",
        "after": "Efter",
        "greaterThan": "Större än",
        "lessThan": "Mindre än",
        "between": "Mellan",
        "isChecked": "Är markerad",
        "isNotChecked": "Är inte kontrollerad"
      },
      "logic": {
        "if": "Om",
        "then": "Gör därefter",
        "and": "Och",
        "or": "Eller"
      },
      "phoneAlertMessage": "För att söka efter telefonnummer med landskod måste du inkludera symbolen ”+” i din sökfråga.",
      "deleteAlertMessage": "Är du säker på att du vill ta bort det här fältet? Villkoret för fältet kommer också att tas bort.",
      "deleteField": "Ta bort fält",
      "jumpToDescription": "Hoppa till en specifik bild när villkoren är uppfyllda",
      "cycleError": "Det går inte att spara. Loop upptäckt mellan {a} och {b}",
      "jumpToSlide": "Hoppa till bild",
      "submitSurvey": "Spara undersökning",
      "pageTitle": "P{index} - {title}",
      "selectSlideToJumpTo": "Välj Skjut att hoppa Från",
      "selectedSlide": "Vald bild",
      "typeValueHere": "Var god ange ett Värde här",
      "field": "Fält",
      "slide": "Bild",
      "selectFieldOrSlide": "Välj Bransch eller Skjut",
      "selectFieldState": "Välj fältstatus",
      "selectField": "Välj fält",
      "selectOption": "Välj alternativ",
      "jumpToTarget": "Hoppa till",
      "jumpToQuestion": "Hoppa till frågan",
      "chooseQuestion": "Välj fråga",
      "includeStart": "Inkludera start",
      "includeEnd": "Inkludera slut",
      "includeValue": "Inkludera {value}",
      "hideField": "Dölj fält",
      "hideFields": "Dölj fält",
      "showField": "Visa fält",
      "showFields": "Visa fält",
      "additionalRulesPrefix": "...och",
      "additionalRulesSuffix": "andra {ifLabel}-regler …",
      "shownTargetsWithMore": "{shown}, +{count} till",
      "noConditionsAlt": "Inga villkor än",
      "outcomeLabels": {
        "show": "Visa",
        "jumpTo": "Hoppa till"
      }
    },
    "minimizedTitlePlaceholder": "Minimerad titel",
    "dragYourElementFromLeft": "Dra dina element hit från vänster",
    "formNotification": "Formuläravisering",
    "sendSubmissionsAsPdf": "Skicka inlämnat formulär som en PDF",
    "style": {
      "formPadding": "Formutfyllnad"
    },
    "integratePopup": {
      "shareOrEmbed": "Bädda in eller dela formuläret",
      "share": {
        "openFormLink": "Öppna Formulär länk"
      },
      "email": {
        "emailSubheader": "Skapa ett tomt E-inlägg och Inbäddad din Formulär, Eller Välj a Mall och Inbäddad it Omedelbart."
      }
    },
    "choosePosition": "Välj Status",
    "testBuild": "Testversion"
  },
  "quiz": {
    "quizElement": "Quizelement",
    "quizNotification": "Quizavisering",
    "viewAndCustomise": "Visa och anpassa",
    "categoryAndScore": "Kategori och poäng",
    "provideFeedback": "Ge feedback",
    "addQuizElement": "Lägg till quizelement",
    "typeOfBuilder": "Quiz",
    "addQuestions": "Lägg till frågor",
    "dragAndDropQuestion": "Dra och släpp ett Fråga här.",
    "addNewPage": "Lägg till en sida",
    "editTemplate": "Redigera Mall",
    "editResultPage": "Redigera resultatsidan",
    "clonePage": "Klona sida",
    "category": {
      "category": "Kategori",
      "useCategoryWhen": "Använd Kategorier När",
      "manageCategories": "Hantera Kategorier",
      "howItWorks2": "Hur fungerar det här",
      "addCategoryMessage": "Lägg till en ny kategori",
      "assignCategoryMessage": "Tilldela ett alternativ i Kategori till varje",
      "editResultsMessage": "Visa Kategori-partitur in Resultat Sida",
      "toEvaluateTheResponder": "Till Jämför baserade respondern På flera faktorer",
      "showMultipleCategoryScore": "Visa multipla Kategori-partitur in Resultat Sida",
      "displayVaryingContent": "Visning varierande Innehåll På resultaten Sida beroende På Poängnivån Kategori",
      "addManage": "Lägg till / Hantera",
      "carouselAlt": "Förhandsgranskning av bild"
    },
    "quizSettings": "Quizinställningar",
    "saveExitConfirmation": "Spara framsteg för frågesporter",
    "onQuizSubmission": "Vid quizinlämning",
    "settings": "Inställningar",
    "deletePage": "Ta bort sida",
    "quizResult": {
      "resultTemplate": "Mall för resultatsida",
      "quizResultAlertMessage": "Den valda resultatsidan visas när quizet är klart",
      "overallScoreLabel": "Totalpoäng",
      "resultTemplateAlt": "Förhandsvisning av quizresultatmall"
    },
    "deleteSlideMessage": "Är du säker på att du vill ta bort den här bilden?",
    "autoResponderSubheader": "Skicka ett automatiskt e-postmeddelande till personen som skickar in quizet (e-postmeddelandet innehåller en kopia av den information som de angav i quizet)",
    "sendSubmissionsAsPdf": "Skicka inlämnat quiz som en PDF",
    "sendQuizResultsAsPdf": "Skicka quizresultat som en PDF",
    "integrateHeader": "Integrera quiz",
    "integrateSubHeader": "Använd följande alternativ för att integrera ditt anpassade quiz på en webbplats",
    "integrateCopyLinkMessage": "Kopiera länken nedan och dela den enkelt var du vill.",
    "pageLabel": "Sida {n}",
    "pageName": "Sidnamn",
    "pagePosition": "Sidposition",
    "createContactOnPartialSubmissionSubText": "Skapar en kontakt när en användare klickar på ”Nästa” på en bild – även om hen inte slutför quizet.",
    "integratePopup": {
      "shareOrEmbed": "Bädda in eller dela quizet",
      "share": {
        "openFormLink": "Öppna Quiz- Länk"
      },
      "email": {
        "emailSubheader": "Skapa ett tomt E-inlägg och Inbäddad ditt quiz, Eller Välj en Mall och Inbäddad it Omelbart."
      }
    }
  },
  "textEditor": {
    "textAlign": "Textjustering",
    "list": "Lista",
    "sourceCode": "Källkod",
    "resetStyle": "Återställ stil",
    "resetDocumentStyle": "Återställ dokumentstil"
  }
}
